// import React, { useState, useEffect } from "react";
// import "react-responsive-carousel/lib/styles/carousel.min.css";
// import { Carousel } from "react-responsive-carousel";
// // import "./styles.scss";
// import { Cursor } from "react-simple-typewriter";
// import Slide0 from "./images/slide-0.png";
// import { scrollToTop } from "../../utils/index";
// import Slide1 from "./images/slide-1.png";
// import Slide2 from "./images/slide-2.png";
// import Slide3 from "./images/slide-3.png";
// import Slide4 from "./images/slide-4.png";
// import Slide5 from "./images/slide-5.png";
// import { Box, Grid, Button, useTheme, useMediaQuery } from "@mui/material";
// import { useNavigate } from "react-router";
// import { useDispatch, useSelector } from "react-redux";
// import { openPremiumSubscriptionModal } from "../../utils/store/slice/appSlice";
// import { homeBookNow, mainBackground3 } from "../../assets";
// import { grey } from "@mui/material/colors";

// const HomeCarousel = () => {
//   const navigate = useNavigate();
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
//   const isTablet = useMediaQuery(theme.breakpoints.down("md"));

//   const [showText, setShowText] = useState(true);
//   const [autoPlay, setAutoPlay] = useState(false);
//   const [clickedButton, setClickButton] = useState();
//   const dispatch = useDispatch();
//   const [currentSlide, setCurrentSlide] = useState(0);
//   const {
//     images: { banner },
//   } = useSelector((state) => state.appSlice);

//   useEffect(() => {
//     scrollToTop();
//   }, []);
//   function useTypewriter({ words, loop, autoPlay }) {
//     const [textIndex, setTextIndex] = useState(0);
//     const [text, setText] = useState("");

//     useEffect(() => {
//       const interval = setInterval(() => {
//         setText(words[textIndex]);
//         setTextIndex((prevIndex) => (prevIndex + 1) % words.length);
//       }, 1000);

//       return () => {
//         clearInterval(interval);
//       };
//     }, [words, loop]);

//     return { text };
//   }

//   const { text } = useTypewriter({
//     words: ["EXCITEMENT", "THRILL", "ENJOYMENT"],
//     loop: {},
//   });

//   useEffect(() => {
//     setTimeout(() => {
//       setAutoPlay(true);
//     }, 3500);
//   }, []);

//   const getTextOverlayStyles = () => ({
//     position: "absolute",
//     top: "50%",
//     left: "50%",
//     transform: "translate(-50%, -50%)",
//     zIndex: "10",
//     width: "100vw",
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "center",
//     gap: "10px",
//   });

//   const getCarouselHeight = () => {
//     if (isMobile) return "calc(100vh - 60px)";
//     if (isTablet) return "calc(100vh - 70px)";
//     return "calc(100vh - 84px)";
//   };

//   return (
//     <>
//       <Grid position={"relative"} sx={{ overflow: "hidden" }}>
//         <Grid sx={getTextOverlayStyles()}>
//           <Grid
//             className="car-top-heading"
//             sx={{
//               zIndex: 1,
//               fontFamily: "Saira",
//               width: "100vw",
//               fontSize: "71px",
//               fontWeight: 800,
//               lineHeight: "112px",
//               letterSpacing: "0em",
//               textAlign: "center",
//               color: "white",
//               "@media (max-width: 1015px)": {
//                 fontSize: "60px",
//                 lineHeight: "60px",
//               },
//               "@media (max-width: 881px)": {
//                 textAlign: "center",
//                 fontSize: "30px",
//                 lineHeight: "30px",
//               },
//               "@media (max-width: 441px)": {
//                 fontSize: "24px",
//                 lineHeight: "28px",
//               },
//             }}
//           >
//             Get Ready For
//           </Grid>
//           <Box
//             component="div"
//             className="car-bottom-heading"
//             sx={{
//               fontFamily: "Luckiest Guy !important",
//               fontSize: "100px !important",
//               fontWeight: "400 !important",
//               lineHeight: "85px !important",
//               letterSpacing: "0em !important",
//               textAlign: "center !important",
//               color: "#fff504 !important",
//               display: "block",
//               "@media (max-width: 1015px)": {
//                 fontSize: "60px !important",
//                 lineHeight: "60px !important",
//               },
//               "@media (max-width: 881px)": {
//                 fontSize: "30px !important",
//                 lineHeight: "50px !important",
//               },
//               "@media (max-width: 441px)": {
//                 fontSize: "32px !important",
//                 lineHeight: "36px !important",
//               },
//             }}
//           >
//             {text} <Cursor />
//           </Box>
//         </Grid>

//         <Grid
//           sx={{
//             transition: "filter 0.3s ease",
//             "&::after": {
//               content: '""',
//               position: "absolute",
//               top: 0,
//               left: 0,
//               right: 0,
//               bottom: 0,
//               background:
//                 "linear-gradient(135deg, rgba(0,0,0,0.2) 0%, rgba(0,0,0,0.1) 100%)",
//               zIndex: 1,
//             },
//           }}
//         >
//           <Carousel
//             autoPlay={autoPlay}
//             centerMode={true}
//             centerSlidePercentage={100}
//             emulateTouch={true}
//             infiniteLoop={true}
//             interval={2500}
//             transitionTime={800}
//             swipeable={true}
//             stopOnHover={false}
//             showArrows={false}
//             showStatus={false}
//             showIndicators={true}
//             showThumbs={false}
//             onChange={(curr) => {
//               setCurrentSlide(curr);
//               if (curr === 1) {
//                 setShowText(false);
//                 setTimeout(() => {
//                   setCurrentSlide(curr);
//                 }, 500);
//               } else {
//                 setTimeout(() => {
//                   setShowText(true);
//                 }, 500);
//               }
//             }}
//           >
//             <Box
//               maxHeight={getCarouselHeight()}
//               sx={{
//                 "-webkit-user-select": "none",
//                 "-ms-user-select": "none",
//                 "user-select": "none",
//                 "& img": {
//                   width: "100%",
//                   height: "100%",
//                   objectFit: "cover",
//                   display: "block",
//                 },
//               }}
//             >
//               <img src={Slide1} alt={"slide 1"} />
//             </Box>

//             <Box
//               maxHeight={getCarouselHeight()}
//               sx={{
//                 "-webkit-user-select": "none",
//                 "-ms-user-select": "none",
//                 "user-select": "none",
//                 "& img": {
//                   width: "100%",
//                   height: "100%",
//                   objectFit: "cover",
//                   display: "block",
//                 },
//               }}
//             >
//               <img src={Slide2} alt={"slide 2"} />
//             </Box>

//             <Box
//               maxHeight={getCarouselHeight()}
//               sx={{
//                 "-webkit-user-select": "none",
//                 "-ms-user-select": "none",
//                 "user-select": "none",
//                 "& img": {
//                   width: "100%",
//                   height: "100%",
//                   objectFit: "cover",
//                   display: "block",
//                 },
//               }}
//             >
//               <img src={Slide3} alt={"slide 3"} />
//             </Box>

//             <Box
//               maxHeight={getCarouselHeight()}
//               sx={{
//                 "-webkit-user-select": "none",
//                 "-ms-user-select": "none",
//                 "user-select": "none",
//                 "& img": {
//                   width: "100%",
//                   height: "100%",
//                   objectFit: "cover",
//                   display: "block",
//                 },
//               }}
//             >
//               <img src={Slide4} alt={"slide 4"} />
//             </Box>

//             <Box
//               maxHeight={getCarouselHeight()}
//               sx={{
//                 "-webkit-user-select": "none",
//                 "-ms-user-select": "none",
//                 "user-select": "none",
//                 "& img": {
//                   width: "100%",
//                   height: "100%",
//                   objectFit: "cover",
//                   display: "block",
//                 },
//               }}
//             >
//               <img src={Slide5} alt={"slide 5"} />
//             </Box>
//             {banner?.map((img) => (
//               <Box
//                 maxHeight={getCarouselHeight()}
//                 key={img._id}
//                 sx={{
//                   "-webkit-user-select": "none",
//                   "-ms-user-select": "none",
//                   "user-select": "none",
//                   "& img": {
//                     width: "100%",
//                     height: "100%",
//                     objectFit: "cover",
//                     display: "block",
//                   },
//                 }}
//               >
//                 <img src={img.url} alt={"banner image"} />
//               </Box>
//             ))}
//           </Carousel>
//         </Grid>
//       </Grid>

//       <Grid
//         container
//         sx={{
//           width: "100vw",
//           height: { xs: "70vh", sm: "80vh", md: "100vh" },
//           background: `url(${Slide5})`,
//           backgroundPosition: "center",
//           backgroundRepeat: "no-repeat",
//           backgroundSize: "cover",
//           position: "relative",
//           "&::before": {
//             content: '""',
//             position: "absolute",
//             top: 0,
//             left: 0,
//             right: 0,
//             bottom: 0,
//             background:
//               "linear-gradient(180deg, rgba(56, 148, 255, 0.85) 0%, rgba(17, 86, 165, 0.85) 100%)",
//             zIndex: 1,
//           },
//         }}
//       >
//         {/* Content Container */}
//         <Grid
//           item
//           xs={12}
//           sx={{
//             display: "flex",
//             flexDirection: "column",
//             justifyContent: { xs: "flex-start", sm: "center" },
//             alignItems: "center",
//             height: "100%",
//             zIndex: 2,
//             position: "relative",
//             gap: 2,
//             px: { xs: 2, sm: 4, md: 6 },
//             pt: { xs: 4, sm: 0 },
//           }}
//         >
//           {/* Button Container */}
//           <Box
//             sx={{
//               display: "flex",
//               flexDirection: "column",
//               gap: 2,
//               width: "100%",
//               maxWidth: { xs: "300px", sm: "400px", md: "500px" },
//             }}
//           >
//             <Button
//               variant="contained"
//               sx={{
//                 backgroundColor: "rgba(255, 255, 255, 0.8)",
//                 boxShadow: "0px 4px 21px -1px rgba(255, 255, 255, 0.8)",
//                 color: "#333",
//                 padding: { xs: "12px 24px", sm: "16px 32px" },
//                 font: "Saira",
//                 fontSize: { xs: "16px", sm: "18px", md: "20px" },
//                 fontWeight: "700",
//                 textTransform: "uppercase",
//                 borderRadius: "bold",
//                 border: "2px solid rgba(255, 255, 255, 0.3)",
//                 backdropFilter: "blur(10px)",
//                 transition: "all 0.3s ease",
//                 "&:hover": {
//                   backgroundColor: "rgba(255, 255, 255, 1)",
//                   transform: "translateY(-2px)",
//                   boxShadow: "0 8px 25px rgba(0, 0, 0, 0.3)",
//                 },
//               }}
//               onClick={() => {
//                 navigate("/packages");
//               }}
//             >
//               PACKAGES
//             </Button>

//             <Button
//               variant="contained"
//               sx={{
//                 backgroundColor: "rgba(255, 255, 255, 0.8)",
//                 boxShadow: "0px 4px 21px -1px rgba(255, 255, 255, 0.8)",
//                 color: "#333",
//                 padding: { xs: "12px 24px", sm: "16px 32px" },
//                 fontSize: { xs: "16px", sm: "18px", md: "20px" },
//                 fontWeight: "bold",
//                 textTransform: "uppercase",
//                 borderRadius: "8px",
//                 border: "2px solid rgba(255, 255, 255, 0.3)",
//                 backdropFilter: "blur(10px)",
//                 transition: "all 0.3s ease",
//                 "&:hover": {
//                   backgroundColor: "rgba(255, 255, 255, 1)",
//                   transform: "translateY(-2px)",
//                   boxShadow: "0 8px 25px rgba(0, 0, 0, 0.3)",
//                 },
//               }}
//               onClick={() => {
//                 navigate("/zone");
//               }}
//             >
//               ACTIVITIES
//             </Button>

//             <Button
//               variant="contained"
//               sx={{
//                 backgroundColor: "rgba(255, 255, 255, 0.8)",
//                 boxShadow: "0px 4px 21px -1px rgba(255, 255, 255, 0.8)",
//                 color: "#333",
//                 padding: { xs: "12px 24px", sm: "16px 32px" },
//                 fontSize: { xs: "16px", sm: "18px", md: "20px" },
//                 fontWeight: "bold",
//                 textTransform: "uppercase",
//                 borderRadius: "8px",
//                 border: "2px solid rgba(255, 255, 255, 0.3)",
//                 backdropFilter: "blur(10px)",
//                 transition: "all 0.3s ease",
//                 "&:hover": {
//                   backgroundColor: "rgba(255, 255, 255, 1)",
//                   transform: "translateY(-2px)",
//                   boxShadow: "0 8px 25px rgba(0, 0, 0, 0.3)",
//                 },
//               }}
//               onClick={() => {
//                 navigate("/events");
//               }}
//             >
//               EVENTS & CELEBRATIONS
//             </Button>

//             <Button
//               variant="contained"
//               sx={{
//                 backgroundColor: "rgba(255, 255, 255, 0.8)",
//                 boxShadow: "0px 4px 21px -1px rgba(255, 255, 255, 0.8)",
//                 color: "#333",
//                 padding: { xs: "12px 24px", sm: "16px 32px" },
//                 fontSize: { xs: "16px", sm: "18px", md: "20px" },
//                 fontWeight: "bold",
//                 textTransform: "uppercase",
//                 borderRadius: "8px",
//                 border: "2px solid rgba(255, 255, 255, 0.3)",
//                 backdropFilter: "blur(10px)",
//                 transition: "all 0.3s ease",
//                 "&:hover": {
//                   backgroundColor: "rgba(255, 255, 255, 1)",
//                   transform: "translateY(-2px)",
//                   boxShadow: "0 8px 25px rgba(0, 0, 0, 0.3)",
//                 },
//               }}
//               onClick={() => {
//                 navigate("/resturant");
//               }}
//             >
//               RESTAURANT & BANQUET HALL
//             </Button>

//             <Button
//               variant="contained"
//               sx={{
//                 backgroundColor: "#4CAF50",
//                 color: "white",
//                 padding: { xs: "14px 28px", sm: "18px 36px" },
//                 fontSize: { xs: "18px", sm: "20px", md: "22px" },
//                 fontWeight: "bold",
//                 textTransform: "uppercase",
//                 borderRadius: "50px",
//                 marginTop: 2,
//                 border: "3px solid rgba(255, 255, 255, 0.3)",
//                 boxShadow: "0 4px 15px rgba(76, 175, 80, 0.4)",
//                 transition: "all 0.3s ease",
//                 "&:hover": {
//                   backgroundColor: "#45a049",
//                   transform: "translateY(-3px) scale(1.02)",
//                   boxShadow: "0 8px 25px rgba(76, 175, 80, 0.6)",
//                 },
//               }}
//               onClick={() => {
//                 navigate("/book");
//               }}
//             >
//               BOOK NOW
//             </Button>
//           </Box>
//         </Grid>
//       </Grid>
//     </>
//   );
// };

// export default HomeCarousel;

import React, { useState, useEffect } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
// import "./styles.scss";
import { Cursor } from "react-simple-typewriter";
import Slide0 from "./images/slide-0.png";
import { scrollToTop } from "../../utils/index";
import Slide1 from "./images/slide-1.png";
import Slide2 from "./images/slide-2.png";
import Slide3 from "./images/slide-3.png";
import Slide4 from "./images/slide-4.png";
import Slide5 from "./images/slide-5.png";
import HoliLogo from "./images/funingoheading.png";
import {
  Box,
  Grid,
  Button,
  useTheme,
  useMediaQuery,
  Modal,
  IconButton,
} from "@mui/material";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { openPremiumSubscriptionModal } from "../../utils/store/slice/appSlice";
import { homeBookNow, mainBackground3 } from "../../assets";
import { grey } from "@mui/material/colors";
import CloseIcon from "@mui/icons-material/Close";

const HomeCarousel = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));

  const [showText, setShowText] = useState(true);
  const [autoPlay, setAutoPlay] = useState(false);
  const [clickedButton, setClickButton] = useState();
  const dispatch = useDispatch();
  const [currentSlide, setCurrentSlide] = useState(0);
  const {
    images: { banner },
  } = useSelector((state) => state.appSlice);

  // ========== HOLI EVENT MODAL STATE - REMOVE AFTER HOLI EVENT ==========
  const [holiModalOpen, setHoliModalOpen] = useState(false);
  // ========== END HOLI EVENT MODAL STATE ==========

  useEffect(() => {
    scrollToTop();
  }, []);

  // ========== HOLI EVENT MODAL AUTO-OPEN & AUTO-CLOSE - REMOVE AFTER HOLI EVENT ==========
  useEffect(() => {
    // Open modal after 1 second when component mounts
    const openTimer = setTimeout(() => {
      setHoliModalOpen(true);
    }, 1000);

    // Auto-close modal after 7 seconds
    const closeTimer = setTimeout(() => {
      setHoliModalOpen(false);
    }, 8000); // 1 second delay + 7 seconds display = 8 seconds total

    return () => {
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
    };
  }, []);

  // Function to manually close the modal
  const handleCloseHoliModal = () => {
    setHoliModalOpen(false);
  };

  // Function to navigate to Holi event page
  const handleHoliEventClick = () => {
    setHoliModalOpen(false);
    navigate("/holievent");
  };
  // ========== END HOLI EVENT MODAL FUNCTIONS ==========

  function useTypewriter({ words, loop, autoPlay }) {
    const [textIndex, setTextIndex] = useState(0);
    const [text, setText] = useState("");

    useEffect(() => {
      const interval = setInterval(() => {
        setText(words[textIndex]);
        setTextIndex((prevIndex) => (prevIndex + 1) % words.length);
      }, 1000);

      return () => {
        clearInterval(interval);
      };
    }, [words, loop]);

    return { text };
  }

  const { text } = useTypewriter({
    words: ["EXCITEMENT", "THRILL", "ENJOYMENT"],
    loop: {},
  });

  useEffect(() => {
    setTimeout(() => {
      setAutoPlay(true);
    }, 3500);
  }, []);

  const getTextOverlayStyles = () => ({
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: "10",
    width: "100vw",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "10px",
  });

  const getCarouselHeight = () => {
    if (isMobile) return "calc(100vh - 60px)";
    if (isTablet) return "calc(100vh - 70px)";
    return "calc(100vh - 84px)";
  };

  return (
    <>

     {/* ========== HOLI EVENT POPUP MODAL ==========  */}
<Modal
  open={holiModalOpen}
  onClose={handleCloseHoliModal}
  aria-labelledby="holi-event-modal"
  aria-describedby="holi-event-description"
  sx={{
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backdropFilter: "blur(8px)",
    backgroundColor: "rgba(0, 0, 0, 0.7)",
  }}
>
  <Box
    sx={{
      position: "relative",
      width: { xs: "95%", sm: "90%", md: "600px" },
      maxWidth: "600px",
      borderRadius: "24px",
      boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.5)",
      animation: "scaleIn 0.3s ease-out",
      "@keyframes scaleIn": {
        from: { opacity: 0, transform: "scale(0.9)" },
        to: { opacity: 1, transform: "scale(1)" },
      },
    }}
  >
    {/* Close Button */}
    <IconButton
      onClick={handleCloseHoliModal}
      sx={{
        position: "absolute",
        top: { xs: 8, sm: 12 },
        right: { xs: 8, sm: 12 },
        zIndex: 10,
        backgroundColor: "rgba(255, 255, 255, 0.95)",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
        width: { xs: "32px", sm: "36px" },
        height: { xs: "32px", sm: "36px" },
        "&:hover": {
          backgroundColor: "rgba(255, 255, 255, 1)",
          transform: "scale(1.1)",
        },
        transition: "all 0.3s ease",
      }}
    >
      <CloseIcon sx={{ color: "#1e40af", fontSize: { xs: "20px", sm: "24px" } }} />
    </IconButton>

    {/* Outer Box - Sky Blue Background - Extended to bottom */}
    <Box
      sx={{
        background: "linear-gradient(180deg, #1e3a8a 0%, #3b82f6 15%, #60a5fa 30%, #93c5fd 50%, #bfdbfe 70%, #dbeafe 85%, #eff6ff 100%)",
        padding: { xs: "24px 16px 40px", sm: "32px 24px 50px", md: "40px 32px 60px" },
        borderRadius: "24px",
        position: "relative",
      }}
    >
      {/* Logo Image */}
      <Box
        sx={{
          marginBottom: { xs: "20px", sm: "24px" },
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <img 
          src={HoliLogo} 
          alt="FUNINGO Holi 2.0" 
          style={{
            width: "100%",
            maxWidth: "380px",
            height: "auto",
          }}
        />
      </Box>

      {/* Outer Card Border - Golden/Yellow with rounded corners */}
      <Box
        sx={{
          background: "linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%)",
          borderRadius: "20px",
          padding: "4px",
          position: "relative",
          boxShadow: "0 4px 12px rgba(251, 191, 36, 0.3)",
          marginBottom: { xs: "35px", sm: "30px" }, // Space for button
        }}
      >
        {/* Inner White Card with Colorful Splash Background */}
        <Box
          sx={{
            backgroundColor: "#ffffff",
            borderRadius: "16px",
            padding: { xs: "24px 16px 24px", sm: "32px 24px 32px", md: "36px 28px 36px" },
            position: "relative",
            overflow: "visible",
            background: `
              radial-gradient(circle at 85% 20%, rgba(236, 72, 153, 0.4) 0%, transparent 45%),
              radial-gradient(circle at 15% 80%, rgba(34, 197, 94, 0.4) 0%, transparent 45%),
              radial-gradient(circle at 50% 50%, rgba(251, 191, 36, 0.2) 0%, transparent 55%),
              #ffffff
            `,
            boxShadow: "inset 0 2px 8px rgba(0, 0, 0, 0.06)",
          }}
        >
          {/* Date */}
          <Box sx={{ marginBottom: "12px" }}>
            <Box
              sx={{
                fontSize: { xs: "16px", sm: "19px", md: "21px" },
                color: "#1e40af",
                fontWeight: 700,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
              }}
            >
              <span style={{ fontSize: "18px" }}>📅</span> March 4, 2026
            </Box>
          </Box>

          {/* Time */}
          <Box sx={{ marginBottom: "20px" }}>
            <Box
              sx={{
                fontSize: { xs: "16px", sm: "19px", md: "21px" },
                color: "#1e40af",
                fontWeight: 700,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
              }}
            >
              <span style={{ fontSize: "18px" }}>🕐</span> 10:00AM - 6:00PM
            </Box>
          </Box>

          {/* Description */}
          <Box
            sx={{
              fontSize: { xs: "13px", sm: "15px", md: "16px" },
              color: "#000000",
              lineHeight: 1.65,
              fontWeight: 500,
              textAlign: "center",
              paddingX: { xs: "8px", sm: "16px", md: "20px" },
            }}
          >
            Join us for an unforgettable celebration of{" "}
            <Box component="span" sx={{ fontWeight: 700 }}>
              colors, culture and adventure!
            </Box>{" "}
            Experience traditional Rajasthani music, dance,{" "}
            <Box component="span" sx={{ fontWeight: 700 }}>
              unlimited rain dance,
            </Box>{" "}
            gulal and much more !
          </Box>
        </Box>

        {/* CTA Button - Positioned below the card */}
        <Box
          sx={{
            position: "absolute",
            bottom: { xs: "-20px", sm: "-25px" },
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 5,
            width: "auto",
          }}
        >
          <Button
            variant="contained"
            onClick={handleHoliEventClick}
            sx={{
              backgroundColor: "#fbbf24",
              color: "#000000",
              padding: { xs: "12px 28px", sm: "15px 42px", md: "17px 50px" },
              fontSize: { xs: "13px", sm: "15px", md: "16px" },
              fontWeight: 700,
              textTransform: "uppercase",
              borderRadius: "50px",
              boxShadow: "0 6px 20px rgba(251, 191, 36, 0.45)",
              border: "none",
              transition: "all 0.3s ease",
              whiteSpace: "nowrap",
              "&:hover": {
                backgroundColor: "#f59e0b",
                transform: "translateY(-3px)",
                boxShadow: "0 10px 30px rgba(251, 191, 36, 0.6)",
              },
            }}
          >
            GRAB YOUR PASS NOW
          </Button>
        </Box>
      </Box>
    </Box>
  </Box>
</Modal>
{/* ========== END HOLI EVENT POPUP MODAL ========== */}

      <Grid position={"relative"} sx={{ overflow: "hidden" }}>
        <Grid sx={getTextOverlayStyles()}>
          <Grid
            className="car-top-heading"
            sx={{
              zIndex: 1,
              fontFamily: "Saira",
              width: "100vw",
              fontSize: "71px",
              fontWeight: 800,
              lineHeight: "112px",
              letterSpacing: "0em",
              textAlign: "center",
              color: "white",
              "@media (max-width: 1015px)": {
                fontSize: "60px",
                lineHeight: "60px",
              },
              "@media (max-width: 881px)": {
                textAlign: "center",
                fontSize: "30px",
                lineHeight: "30px",
              },
              "@media (max-width: 441px)": {
                fontSize: "24px",
                lineHeight: "28px",
              },
            }}
          >
            Get Ready For
          </Grid>
          <Box
            component="div"
            className="car-bottom-heading"
            sx={{
              fontFamily: "Luckiest Guy !important",
              fontSize: "100px !important",
              fontWeight: "400 !important",
              lineHeight: "85px !important",
              letterSpacing: "0em !important",
              textAlign: "center !important",
              color: "#fff504 !important",
              display: "block",
              "@media (max-width: 1015px)": {
                fontSize: "60px !important",
                lineHeight: "60px !important",
              },
              "@media (max-width: 881px)": {
                fontSize: "30px !important",
                lineHeight: "50px !important",
              },
              "@media (max-width: 441px)": {
                fontSize: "32px !important",
                lineHeight: "36px !important",
              },
            }}
          >
            {text} <Cursor />
          </Box>
        </Grid>

        <Grid
          sx={{
            transition: "filter 0.3s ease",
            "&::after": {
              content: '""',
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background:
                "linear-gradient(135deg, rgba(0,0,0,0.2) 0%, rgba(0,0,0,0.1) 100%)",
              zIndex: 1,
            },
          }}
        >
          <Carousel
            autoPlay={autoPlay}
            centerMode={true}
            centerSlidePercentage={100}
            emulateTouch={true}
            infiniteLoop={true}
            interval={2500}
            transitionTime={800}
            swipeable={true}
            stopOnHover={false}
            showArrows={false}
            showStatus={false}
            showIndicators={true}
            showThumbs={false}
            onChange={(curr) => {
              setCurrentSlide(curr);
              if (curr === 1) {
                setShowText(false);
                setTimeout(() => {
                  setCurrentSlide(curr);
                }, 500);
              } else {
                setTimeout(() => {
                  setShowText(true);
                }, 500);
              }
            }}
          >
            <Box
              maxHeight={getCarouselHeight()}
              sx={{
                "-webkit-user-select": "none",
                "-ms-user-select": "none",
                "user-select": "none",
                "& img": {
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  display: "block",
                },
              }}
            >
              <img src={Slide1} alt={"slide 1"} />
            </Box>

            <Box
              maxHeight={getCarouselHeight()}
              sx={{
                "-webkit-user-select": "none",
                "-ms-user-select": "none",
                "user-select": "none",
                "& img": {
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  display: "block",
                },
              }}
            >
              <img src={Slide2} alt={"slide 2"} />
            </Box>

            <Box
              maxHeight={getCarouselHeight()}
              sx={{
                "-webkit-user-select": "none",
                "-ms-user-select": "none",
                "user-select": "none",
                "& img": {
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  display: "block",
                },
              }}
            >
              <img src={Slide3} alt={"slide 3"} />
            </Box>

            <Box
              maxHeight={getCarouselHeight()}
              sx={{
                "-webkit-user-select": "none",
                "-ms-user-select": "none",
                "user-select": "none",
                "& img": {
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  display: "block",
                },
              }}
            >
              <img src={Slide4} alt={"slide 4"} />
            </Box>

            <Box
              maxHeight={getCarouselHeight()}
              sx={{
                "-webkit-user-select": "none",
                "-ms-user-select": "none",
                "user-select": "none",
                "& img": {
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  display: "block",
                },
              }}
            >
              <img src={Slide5} alt={"slide 5"} />
            </Box>
            {banner?.map((img) => (
              <Box
                maxHeight={getCarouselHeight()}
                key={img._id}
                sx={{
                  "-webkit-user-select": "none",
                  "-ms-user-select": "none",
                  "user-select": "none",
                  "& img": {
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    display: "block",
                  },
                }}
              >
                <img src={img.url} alt={"banner image"} />
              </Box>
            ))}
          </Carousel>
        </Grid>
      </Grid>

      <Grid
        container
        sx={{
          width: "100vw",
          height: { xs: "70vh", sm: "80vh", md: "100vh" },
          background: `url(${Slide5})`,
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          position: "relative",
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background:
              "linear-gradient(180deg, rgba(56, 148, 255, 0.85) 0%, rgba(17, 86, 165, 0.85) 100%)",
            zIndex: 1,
          },
        }}
      >
        {/* Content Container */}
        <Grid
          item
          xs={12}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: { xs: "flex-start", sm: "center" },
            alignItems: "center",
            height: "100%",
            zIndex: 2,
            position: "relative",
            gap: 2,
            px: { xs: 2, sm: 4, md: 6 },
            pt: { xs: 4, sm: 0 },
          }}
        >
          {/* Button Container */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2,
              width: "100%",
              maxWidth: { xs: "300px", sm: "400px", md: "500px" },
            }}
          >
            <Button
              variant="contained"
              sx={{
                backgroundColor: "rgba(255, 255, 255, 0.8)",
                boxShadow: "0px 4px 21px -1px rgba(255, 255, 255, 0.8)",
                color: "#333",
                padding: { xs: "12px 24px", sm: "16px 32px" },
                font: "Saira",
                fontSize: { xs: "16px", sm: "18px", md: "20px" },
                fontWeight: "700",
                textTransform: "uppercase",
                borderRadius: "bold",
                border: "2px solid rgba(255, 255, 255, 0.3)",
                backdropFilter: "blur(10px)",
                transition: "all 0.3s ease",
                "&:hover": {
                  backgroundColor: "rgba(255, 255, 255, 1)",
                  transform: "translateY(-2px)",
                  boxShadow: "0 8px 25px rgba(0, 0, 0, 0.3)",
                },
              }}
              onClick={() => {
                navigate("/packages");
              }}
            >
              PACKAGES
            </Button>

            <Button
              variant="contained"
              sx={{
                backgroundColor: "rgba(255, 255, 255, 0.8)",
                boxShadow: "0px 4px 21px -1px rgba(255, 255, 255, 0.8)",
                color: "#333",
                padding: { xs: "12px 24px", sm: "16px 32px" },
                fontSize: { xs: "16px", sm: "18px", md: "20px" },
                fontWeight: "bold",
                textTransform: "uppercase",
                borderRadius: "8px",
                border: "2px solid rgba(255, 255, 255, 0.3)",
                backdropFilter: "blur(10px)",
                transition: "all 0.3s ease",
                "&:hover": {
                  backgroundColor: "rgba(255, 255, 255, 1)",
                  transform: "translateY(-2px)",
                  boxShadow: "0 8px 25px rgba(0, 0, 0, 0.3)",
                },
              }}
              onClick={() => {
                navigate("/zone");
              }}
            >
              ACTIVITIES
            </Button>

            <Button
              variant="contained"
              sx={{
                backgroundColor: "rgba(255, 255, 255, 0.8)",
                boxShadow: "0px 4px 21px -1px rgba(255, 255, 255, 0.8)",
                color: "#333",
                padding: { xs: "12px 24px", sm: "16px 32px" },
                fontSize: { xs: "16px", sm: "18px", md: "20px" },
                fontWeight: "bold",
                textTransform: "uppercase",
                borderRadius: "8px",
                border: "2px solid rgba(255, 255, 255, 0.3)",
                backdropFilter: "blur(10px)",
                transition: "all 0.3s ease",
                "&:hover": {
                  backgroundColor: "rgba(255, 255, 255, 1)",
                  transform: "translateY(-2px)",
                  boxShadow: "0 8px 25px rgba(0, 0, 0, 0.3)",
                },
              }}
              onClick={() => {
                navigate("/events");
              }}
            >
              EVENTS & CELEBRATIONS
            </Button>

            <Button
              variant="contained"
              sx={{
                backgroundColor: "rgba(255, 255, 255, 0.8)",
                boxShadow: "0px 4px 21px -1px rgba(255, 255, 255, 0.8)",
                color: "#333",
                padding: { xs: "12px 24px", sm: "16px 32px" },
                fontSize: { xs: "16px", sm: "18px", md: "20px" },
                fontWeight: "bold",
                textTransform: "uppercase",
                borderRadius: "8px",
                border: "2px solid rgba(255, 255, 255, 0.3)",
                backdropFilter: "blur(10px)",
                transition: "all 0.3s ease",
                "&:hover": {
                  backgroundColor: "rgba(255, 255, 255, 1)",
                  transform: "translateY(-2px)",
                  boxShadow: "0 8px 25px rgba(0, 0, 0, 0.3)",
                },
              }}
              onClick={() => {
                navigate("/resturant");
              }}
            >
              RESTAURANT & BANQUET HALL
            </Button>

            <Button
              variant="contained"
              sx={{
                backgroundColor: "#4CAF50",
                color: "white",
                padding: { xs: "14px 28px", sm: "18px 36px" },
                fontSize: { xs: "18px", sm: "20px", md: "22px" },
                fontWeight: "bold",
                textTransform: "uppercase",
                borderRadius: "50px",
                marginTop: 2,
                border: "3px solid rgba(255, 255, 255, 0.3)",
                boxShadow: "0 4px 15px rgba(76, 175, 80, 0.4)",
                transition: "all 0.3s ease",
                "&:hover": {
                  backgroundColor: "#45a049",
                  transform: "translateY(-3px) scale(1.02)",
                  boxShadow: "0 8px 25px rgba(76, 175, 80, 0.6)",
                },
              }}
              onClick={() => {
                navigate("/book");
              }}
            >
              BOOK NOW
            </Button>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default HomeCarousel;
